/* eslint-disable no-restricted-imports */
import { DpIARecommendationResponse } from 'integration/generated/transactions/data-contracts';
import valueIsArray from 'integration/utils/typeAssertions/valueIsArray';
import valueIsRecord from 'integration/utils/typeAssertions/valueIsRecord';
import valueIsString from 'integration/utils/typeAssertions/valueIsString';

type IARecommendationType = 'recommendation' | 'outfit' | 'complements';

export const partNumbersIARecommendationExtractorByUnknown = (
	type: IARecommendationType,
	data: unknown
): string[] => {
	if (!valueIsRecord(data)) {
		return [];
	}

	const innerData = (data as DpIARecommendationResponse).data;
	if (!valueIsRecord(innerData)) {
		return [];
	}

	const key = type === 'recommendation' ? 'recommendations' : type;
	const list = (innerData as Record<string, unknown>)[key];
	if (!valueIsArray(list)) {
		return [];
	}

	return list.map((item) => (valueIsRecord(item) ? item?.id : undefined)).filter(valueIsString);
};
